import React from "react";
import { LINE_HORIZONTAL_SPACING } from "../../styles/spacing";

type LineHorizontalSpaceProps = {};

export const LineHorizontalSpace = (props: LineHorizontalSpaceProps) => {
  return <div style={{ width: LINE_HORIZONTAL_SPACING }} />;
};
